/* Everest VW standard buy box (Get You Booked, Oct 2026). Pairs with snippets/ev-buy-box.liquid.
   Works out the variant from the option cards or dropdowns, then updates the price, the saving, the
   Add to basket button and the page address. Adding to the basket is Dawn's product-form. */
(function () {
  'use strict';

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function init(box) {
    if (box.dataset.evbuyReady) return;
    box.dataset.evbuyReady = '1';
    var json = box.querySelector('[data-evbuy-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = box.querySelector('[data-evbuy-id]');
    var now = box.querySelector('[data-evbuy-now]');
    var was = box.querySelector('[data-evbuy-was]');
    var save = box.querySelector('[data-evbuy-save]');
    var btn = box.querySelector('[data-evbuy-add]');
    var btnText = btn && btn.querySelector('span');

    function selected() {
      var radio = box.querySelector('[data-evbuy-radio]:checked');
      if (radio) {
        return variants.find(function (v) { return String(v.id) === radio.value; });
      }
      var selects = box.querySelectorAll('[data-evbuy-select]');
      if (selects.length) {
        var values = Array.prototype.map.call(selects, function (s) { return s.value; });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === values[i]; });
        });
      }
      return variants.find(function (v) { return String(v.id) === idInput.value; });
    }

    function update() {
      var v = selected();
      if (!btn || !btnText) return;
      if (!v) {
        btn.disabled = true;
        btnText.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      now.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      was.hidden = !onSale;
      save.hidden = !onSale;
      if (onSale) {
        was.textContent = money(v.compare_at_price);
        save.textContent = box.dataset.saveLabel.replace('[amount]', money(v.compare_at_price - v.price));
      }
      btn.disabled = !v.available;
      btn.removeAttribute('aria-disabled');
      btnText.textContent = v.available ? btn.dataset.addLabel : btn.dataset.soldLabel;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
      box.dispatchEvent(new CustomEvent('evbuy:variant', { bubbles: true, detail: { variant: v } }));
    }

    box.addEventListener('change', function (e) {
      if (e.target.matches('[data-evbuy-radio], [data-evbuy-select]')) update();
    });
  }

  function start() {
    document.querySelectorAll('[data-evbuy]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();